import HTMLTemplate from './template.html'
import { AirportPins } from '../AirportPins/AirportPins'
import './styles.scss'
import SecurityCMS from '../../services/api/SecurityCMS/ApiService'
import ClientPortalAPIService from '../../services/api/ClientPortal/ApiService'
import { extractImageRelativePathFromDOMString } from '../../services/utils'
import { config } from '../../Config'
import tippy, { followCursor } from 'tippy.js';
import { riskDefinitions } from './../../RiskDefinitions'
import { highlightCountry, unhighlightCountry, mapflyToLocation } from './../../services/airport'
import Export from '../../modules/export'
import MixPanelService from '../../services/MixPanelService'
import { groupBy, cloneDeep, startCase, camelCase } from 'lodash'
import { ModalComponent } from '../Modal/Modal'
import AeroSpace from '../../modules/aerospace'
import InternationalSOSAlerts from '../../modules/InternationalSOSAlerts'
import AvsecAlerts from '../../modules/avsecAlerts'
import { COUNTRY_DETAILS } from '../../data/country-details'
import { FIR_DETAILS } from '../../data/fir-details'
import moment from 'moment'
import 'moment-timezone'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import isEmail from 'validator/lib/isEmail'
import User from '../../modules/user'
import MapBox from '../../modules/map'
import { Compare } from '../Compare/Compare'
import { filterInternationalSOSAlerts, filterInternationalSOSCountryAlerts, findIfAlertsAreInAirportRange } from '../../services/EventsService'
import { BriefBuilderComponent } from '../BriefBuilder/BriefBuilder'
import { SideNavigation } from '../SideNavigation/SideNavigation'

export const DetailsPanel = (() => {
    const airportDetails = {
        publishedDate: '',
        overview: {
            runwaySpecs: '',
            groundHandling: '',
            airportEntry: '',
            timeZone: '',
            internationalStandard: '',
            airportContacts: '',
            airportMapURL: '',
            airportType: ''
        },
        operations: {
            airportSummary: '',
            groundTransport: '',
        },
        security: {
            assessment: ''
        },
        aviationAlerts: []
    }

    // Commented items will need to be connected to the proxy API, they don't come through Security CMS, but
    // we will connect them from Country guides API
    const cityDetails = {
        publishedDate: '',
        overview: {
            // portOfEntry: '',
            securityOverview: '',
            orientation: '',
            cityCalendar: ''
        },
        security: {
            seekingHelp: '',
            crime: '',
            socialUnrest: '',
            terrorism: '',
            troubleSpots: ''
        },
        transport: {
            toCityCentre: '',
            taxis: '',
            publicTransport: '',
            walking: '',
            carHire: ''
        },
        keyinfo: {
            // curfews: '',
            diplomaticRepresentation: '',
            emergencyMedicalCare: '',
            emergencyNumbers: '',
            lodging: ''
        },
        alerts: [],
        aviationAlerts: []
    }

    const countryDetails = {
        publishedDate: '',
        overview: {
            assessment: '',
            conclusion: '',
            emergencyNumbers: ''
        },
        travel: {
            riskSummary: '',
            securityAlerts: '',
            standingTravelAdvice: '',
            businessWomen: '',
            entryExitRequirements: ''
        },
        background: {
            countryRuleOfLaw: '',
            countryConflict: '',
            politicalSituation: '',
            countryCorruption: '',
            borderConcerns: '',
            socialUnrest: '',
            naturalDisasters: '',
            recentHistory: ''
        },
        alerts: [],
        aviationAlerts: [],
        isMedicalLoading: false,
        medical: {
            waterrisk: '',
            foodrisk: '',
            vaccination: [],
            routinevaccination: [],
            medicalalertteaser: [],
            emgresponse: '',
            outpatientcare: '',
            healthcarepayment: '',
            dentalcare: '',
            availmeds: '',
            bloodsupplies: '',
            diseases: [],
            GeneralDiseaseAndPreventionContent: [],
            medicalReferrals: []
        }
    }

    const airspaceDetails = {
        publishedDate: '',
        anyInformation: false,
        airspaceIdentifier: '',
        airspaceCode: '',
        countryName: '',
        ISO_3166_1_ALPHA_3: '',
        countryThreatTypes: [],
        restrictions: [],
        groupedRestrictions: [],
        highestWeaponaryMaxEffectiveAltitude: 0,
        highestFlightRestriction: 0,
        overview: {
            assessment: '',
            recommendation: '',
            introduction: '',
            map: ''
        },
        weaponry: {
            introduction: '',
            availability: '',
            directAttacks: '',
            documentedUseCivilAviation: '',
            documentedUseMilitaryAviation: '',
            IDFAttacks: ''
        },
        aviation: {
            summary: '',
            advice: '',
            airspaceProhibition: '',
            alerts: ''
        },
        aviationAlerts: []
    }

    // Flight Information Region Details
    const FIRDetails = {
        name: '',
        code: '',
        airspaces: [], // This is an array of all airspaces that and FIR can have, this is the same type as `airspaceDetails`
        aviationAlerts: []
    }

    const countryCovidRestrictions = {
        impactRatings: {
            domesticOperations: 0,
            travel: 0
        },
        generalRating: 0,
        restrictionList: [],
        domesticRatingDisplay: '',
        travelRatingDisplay: ''
    }

    const guessedTimeZone = moment.tz(moment.tz.guess()).format('z')

    const vueComponent = {
        data() {
            return {
                airportBasicData: {},
                airportCurrentTab: 'Overview', // Operations, Security, Medical, Tails
                cityCurrentTab: 'Overview', // Security, Transport, Key Info
                countryCurrentTab: 'Overview', // Travel, Background, Weaponry, Aviation
                airspaceCurrentTab: 'CZ Warnings', // Overview, Incidents
                airportDetails: cloneDeep(airportDetails),
                cityDetails: cloneDeep(cityDetails),
                countryDetails: cloneDeep(countryDetails),
                airspaceDetails: cloneDeep(airspaceDetails),
                FIRDetails: cloneDeep(FIRDetails),
                ativeFIRAirspaceIndex: 0,
                isLoading: false,
                warningsAndRestrictions: [],
                covidRestrictions: {
                    countryRestrictions: [],
                    covidImpactDefinitions: {
                        travel: {},
                        domesticOperations: {}
                    }
                },
                currentCountryCovidRestrictions: countryCovidRestrictions,
                isAirportPinned: false,
                isDetailsPanelOpen: false,
                currentActiveModule: 'airport', // city, country, airspace, FIR
                missingInformationBanner: `
                    <div class="banner__content">
                        <h4 class="banner__title f-subheading">Contact MedAire for information on this location</h4>
                        <p class="banner__text">Our team can provide a full security and medical report for this location on request</p>
                    </div>
                    <div class="banner__action">
                        <button" class="button button--1 button--sm button--spaced request-info-button" type="button">
                            <span class="button__text">Request Info</span>
                        </button>
                    </div>
                `,
                riskDefinitions: riskDefinitions,
                countriesWeaponaryData: [],
                expandAssociatedAlerts: false,

                userEmail: '',
                userName: '',
                userCompany: '',
                userPermissions: [],
                userAirportCodePreference: 'ICAO',

                requestInfoAirportCode: '',
                requestInfoAirport: '',
                requestInfoCity: '',
                requestInfoCountry: '',

                requestInfoTitle: '',
                requestInfoSubtitle: '',
                requestInfoUserEmail: '',
                requestInfoUserName: '',
                requestInfoUserCompany: '',
                requestInfoUserAdditionalNote: '',
                requestInfoSubmitted: false,
                isSubmittingRequestInfo: false,
                requestInfoSuccessfullySubmitted: false,
                requestInfoAPIError: '',
                requestInfoType: '',
                latestCreatedDateAirSpace: '',
                latestCreatedDateAirSpaceFIR: {
                },
                allAirportAlertAlerts: [],
                allCityAlertAlerts: [],
                allCountryAlerts: [],
                allAirspaceAlerts: [],
                isLoadingBriefBuilder: false
            }
        },
        created() {
            User.getLocalUserInfo().then(user => {
                this.userEmail = user.email
                this.userName = user.name
                this.userCompany = user.Client
                this.requestInfoUserEmail = user.email
                this.requestInfoUserName = user.name
                this.requestInfoUserCompany = user.Client
            })

            User.getUserPermissions().then(permissions => this.userPermissions = permissions)
        },
        mounted() {
            this.subscribeToUserSettingsChanges()
            window.addEventListener('resize', this.updateAccordionHeights)
        },
        unmounted() {
            window.addEventListener('resize', this.updateAccordionHeights)
        },
        methods: {
            subscribeToUserSettingsChanges() {
                window.setInterval(() => this.userAirportCodePreference = User.userSettings.airportCode, 2500)
            },
            urlify(content) {
                var regex = /((?:href|src)=")?(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
                return content.replace(regex, function (match, attr) {
                    if (typeof attr != 'undefined') {
                        return match
                    }
                    return '<a target="_blank" href="' + match + '">' + match + '</a>'
                })
            },
            showRequestInfoFlyout(event) {
                if (event.target.classList.contains('request-info-button')) {
                    this.requestInfoUserEmail = this.userEmail
                    this.requestInfoUserName = this.userName
                    this.requestInfoUserCompany = this.userCompany
                    this.requestInfoUserAdditionalNote = ''
                    this.requestInfoAirportCode = ''
                    this.requestInfoAirport = ''
                    this.requestInfoCity = ''
                    this.requestInfoCountry = ''
                    document.getElementsByClassName('app-template')[0].classList.add('request-info-show')
                }
            },
            showRequestInfoAirport(event, code, name) {
                this.showRequestInfoFlyout(event)
                this.requestInfoType = 'airport'
                this.requestInfoAirportCode = code
                this.requestInfoAirport = name
                this.requestInfoTitle = code
                this.requestInfoSubtitle = name
            },
            showRequestInfoCountry(event, country) {
                this.showRequestInfoFlyout(event)
                this.requestInfoType = 'country'
                this.requestInfoCountry = country
                this.requestInfoTitle = country
                this.requestInfoSubtitle = ''
            },
            showRequestInfoCity(event, city, country) {
                this.showRequestInfoFlyout(event)
                this.requestInfoType = 'city'
                this.requestInfoCity = city
                this.requestInfoCountry = country
                this.requestInfoTitle = city
                this.requestInfoSubtitle = country
            },
            showRequestInfoAirspace(event, country) {
                this.showRequestInfoFlyout(event)
                this.requestInfoType = 'airspace'
                this.requestInfoCountry = country
                this.requestInfoTitle = country
                this.requestInfoSubtitle = ''
            },
            hideRequestInfo() {
                document.getElementsByClassName('app-template')[0].classList.remove('request-info-show')
            },
            submitInfoRequest() {
                this.requestInfoAPIError = ''
                this.requestInfoSubmitted = true

                if (!isEmail(this.requestInfoUserEmail)) return
                if (this.requestInfoUserName.trim() === '') return
                if (this.requestInfoUserCompany.trim() === '') return

                this.isSubmittingRequestInfo = true

                MixPanelService.track('Request Info Submit')

                ClientPortalAPIService.submitRequestInfo({
                    userEmail: this.requestInfoUserEmail,
                    userName: this.requestInfoUserName,
                    userCompany: this.requestInfoUserCompany,
                    userAdditionalNote: this.requestInfoUserAdditionalNote,
                    userRequestInfoForAirportCode: this.requestInfoAirportCode,
                    userRequestInfoForAirport: this.requestInfoAirport,
                    userRequestInfoForCity: this.requestInfoCity,
                    userRequestInfoForCountry: this.requestInfoCountry,
                    userRequestInfoForType: this.requestInfoType,
                    type: "request info"
                })
                    .then((responseData) => {
                        // TODO: check for successful response, otherwise display an error, need to have API working to check how it will return that status
                        this.requestInfoSuccessfullySubmitted = true
                    })
                    .catch(error => {
                        Sentry.captureException(error)
                        this.requestInfoAPIError = error
                    }).
                    then(() => {
                        this.isSubmittingRequestInfo = false
                        setTimeout(() => {
                            if (this.requestInfoAPIError === '') {
                                this.requestInfoSuccessfullySubmitted = false
                                this.hideRequestInfo()
                            } else {
                                this.requestInfoAPIError = ''
                            }
                        }, 3000);
                    })
            },
            isValidEmail(email) {
                return isEmail(email)
            },
            toggleAccordion(event, element) {
                let accordion = null

                if (element !== undefined) {
                    accordion = element
                } else {
                    accordion = event.target.parentElement
                }

                const contentContainer = accordion.getElementsByClassName('accordion__content-container')[0]
                const contentHeight = accordion.getElementsByClassName('accordion__content')[0].offsetHeight
                if (accordion.classList.contains("show-content")) {
                    accordion.classList.remove('show-content');
                    contentContainer.setAttribute("style", "height: 0")
                } else {
                    accordion.classList.add('show-content');
                    contentContainer.setAttribute("style", "height:" + (parseInt(contentHeight) + 16) + "px")
                }
            },
            updateAccordionHeights() {
                setTimeout(() => {
                    const accordionContainer = document.getElementsByClassName('show-content')
                    if (accordionContainer.length > 0) {
                        for (let index = 0; index < accordionContainer.length; index++) {
                            const contentContainer = accordionContainer[index].getElementsByClassName('accordion__content-container')[0]
                            const contentHeight = accordionContainer[index].getElementsByClassName('accordion__content')[0].offsetHeight
                            contentContainer.setAttribute("style", "height:" + (parseInt(contentHeight) + 16) + "px")
                        }
                    }
                }, 250)
            },
            seeCovidDetails() {
                this.currentActiveModule = 'country'
                this.countryCurrentTab = 'Travel'

                this.$nextTick(() => {
                    if (this.$refs.countryCovidRestrictionsAccordian !== undefined &&
                        !this.$refs.countryCovidRestrictionsAccordian.classList.contains('show-content')) {
                        this.toggleAccordion(null, this.$refs.countryCovidRestrictionsAccordian)
                    }
                })
            },
            showLoadingSkeleton() {
                this.$refs.detailsPanelBody.scrollTop = 0;
                document.getElementsByClassName('details-panel')[0].classList.add('show-skeleton')
                document.getElementsByClassName('details-panel')[0].classList.remove('hide-skeleton')
                document.getElementsByClassName('generate-report')?.[0]?.classList?.add('disabled', 'is-loading')
            },
            hideLoadingSkeleton() {
                this.$refs.detailsPanelBody.scrollTop = 0;
                document.getElementsByClassName('details-panel')[0].classList.remove('show-skeleton')
                document.getElementsByClassName('details-panel')[0].classList.add('hide-skeleton')
                this.isParentObjectEmptyForBriefBuilder()
            },
            findCountryCovidRestrictions(countryISO) {
                return this.covidRestrictions?.countryRestrictions?.find(country => {
                    return country.countryISO === countryISO
                })
            },
            findCountryWeaponaryData(countryISO) {
                return this.countriesWeaponaryData?.find(country => {
                    return country.CountryCodeAlpha3 === countryISO
                })
            },
            findCountryRestrictions(countryISO) {
                return this.warningsAndRestrictions.filter(restriction => {
                    const affectedFIRs = restriction.affectedFIRs.split(',')
                    return affectedFIRs.some(affectedFIR => {
                        let affectedFIRName = affectedFIR.trim()
                        const FIR_DETAIL = FIR_DETAILS[affectedFIRName]
                        if (FIR_DETAIL === undefined) {
                            return false
                        } else {
                            return FIR_DETAILS[affectedFIRName].countries.indexOf(countryISO) > -1
                        }
                    })
                })
            },
            getProcessedAirspaceData(ISO_3166_1_ALPHA_3, countryName, airspaceCode = '') {
                let airspace = cloneDeep(airspaceDetails)
                airspace.countryName = countryName
                airspace.ISO_3166_1_ALPHA_3 = ISO_3166_1_ALPHA_3
                airspace.airspaceCode = airspaceCode

                const countryWeaponaryData = this.findCountryWeaponaryData(ISO_3166_1_ALPHA_3)
                if (countryWeaponaryData !== undefined) {
                    airspace.airspaceIdentifier = countryWeaponaryData?.Value?.AirspaceIdentifier
                    airspace.countryThreatTypes = countryWeaponaryData?.Value?.CountryThreatTypes || []
                }

                const airspaceRestrictions = this.findCountryRestrictions(ISO_3166_1_ALPHA_3)
                airspace.restrictions = airspaceRestrictions
                airspace.groupedRestrictions = groupBy(airspaceRestrictions, restriction => restriction.issuingCountryName)

                // Find highest weaponary threat level
                airspace.countryThreatTypes.forEach(threatType => {
                    if (threatType.MaxEffectiveAltitude > airspace.highestWeaponaryMaxEffectiveAltitude)
                        airspace.highestWeaponaryMaxEffectiveAltitude = threatType.MaxEffectiveAltitude
                })

                // Find highest flight restriction level
                airspace.restrictions.forEach(restriction => {
                    if (restriction.flightLevel > airspace.highestFlightRestriction)
                        airspace.highestFlightRestriction = restriction.flightLevel
                })

                return airspace
            },
            getProcessedAirspaceAPIResult(APIResult, airspaceDetails, isFirPanel = false) {
                // 09/02/2022 - Put double condition for smooth transition, but somewhere after 15/02/2022 all conditions beginning with "AA -" can be removed
                if (APIResult.Name === 'AA - Assessment' || APIResult.Name === 'Assessment') {
                    airspaceDetails.overview.assessment = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.overview.assessment && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'AA - Conclusion' || APIResult.Name === 'Conclusion') {
                    airspaceDetails.overview.recommendation = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.overview.recommendation && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'AA Intro' || APIResult.Name === 'Intro') {
                    airspaceDetails.overview.introduction = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.overview.introduction && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if ((APIResult.Name === 'AA - Cover Map' || APIResult.Name === 'Cover Map') && APIResult.Value.Content !== '') {
                    const imagePath = extractImageRelativePathFromDOMString(APIResult.Value.Content)
                    if (imagePath !== '') airspaceDetails.overview.map = config.MedaireSecurityCMSPortal + imagePath
                    if (airspaceDetails.overview.map && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Country Intro - Lethality') {
                    airspaceDetails.weaponry.introduction = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.weaponry.introduction && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Country Intro - Availability') {
                    airspaceDetails.weaponry.availability = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.weaponry.availability && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Direct Attacks') {
                    airspaceDetails.weaponry.directAttacks = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.weaponry.directAttacks && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Documented Use') {
                    airspaceDetails.weaponry.documentedUseMilitaryAviation = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.weaponry.documentedUseMilitaryAviation && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Documented Use 2') {
                    airspaceDetails.weaponry.documentedUseCivilAviation = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.weaponry.documentedUseCivilAviation && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'IDF Attacks') {
                    airspaceDetails.weaponry.IDFAttacks = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.weaponry.IDFAttacks && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Aviation Summary') {
                    airspaceDetails.aviation.summary = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.aviation.summary && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Aviation Advise') {
                    airspaceDetails.aviation.advice = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.aviation.advice && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Pilot Issues') {
                    airspaceDetails.aviation.pilotIssues = this.getSecurityCMSAPIResponse(APIResult.Value)
                    if (airspaceDetails.aviation.pilotIssues && APIResult.ContentType !== 'API-Content') {
                        this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                    }
                }

                if (APIResult.Name === 'Aviation Alerts' && APIResult.Country !== '' && APIResult.City === '' && !!APIResult?.Value?.Body) {
                    try {
                        this.airspaceDetails.aviation.alerts = JSON.parse(APIResult.Value.Body).Alerts
                        if (this.airspaceDetails.aviation.alerts && APIResult.ContentType !== 'API-Content') {
                            this.calculateLatestDate(APIResult, airspaceDetails, isFirPanel)
                        }
                    } catch { this.airspaceDetails.aviation.alerts = APIResult.Value.Body }

                }
                return airspaceDetails
            },
            calculateLatestDate(data, airspaceDetails, isFirPanel) {
                if (data.ContentType !== 'API-Content') {
                    data.CreatedDate = data.CreatedDate ? moment(data.CreatedDate + 'Z') : ''
                    if (isFirPanel) {
                        let FIRLatestDate = this.latestCreatedDateAirSpaceFIR?.[airspaceDetails.ISO_3166_1_ALPHA_3] || ''
                        if (data.CreatedDate.isAfter(FIRLatestDate) || FIRLatestDate === '') {
                            this.latestCreatedDateAirSpaceFIR[airspaceDetails.ISO_3166_1_ALPHA_3] = data.CreatedDate
                        }

                    } else {
                        if (data.CreatedDate.isAfter(this.latestCreatedDateAirSpace) || this.latestCreatedDateAirSpace === '') {
                            this.latestCreatedDateAirSpace = data.CreatedDate
                        }
                    }
                }
            },
            checkForAnyAirspaceInformation(airspaceDetails) {
                airspaceDetails.anyInformation = true
                if (airspaceDetails.countryThreatTypes.length === 0 &&
                    airspaceDetails.restrictions.length === 0 &&
                    airspaceDetails.overview.assessment === '' &&
                    airspaceDetails.overview.recommendation === '' &&
                    airspaceDetails.overview.introduction === '' &&
                    airspaceDetails.overview.map === '' &&
                    airspaceDetails.weaponry.introduction === '' &&
                    airspaceDetails.weaponry.availability === '' &&
                    airspaceDetails.weaponry.directAttacks === '' &&
                    airspaceDetails.weaponry.documentedUseMilitaryAviation === '' &&
                    airspaceDetails.weaponry.documentedUseCivilAviation === '' &&
                    airspaceDetails.weaponry.IDFAttacks === '' &&
                    airspaceDetails.aviation.summary === '' &&
                    airspaceDetails.aviation.advice === '' &&
                    airspaceDetails.aviation.alerts === '') {
                    airspaceDetails.anyInformation = false
                }

                return airspaceDetails
            },
            showFlightInformationRegionDetails(airspaceCode, controllingCountryCode, FIRName, countries) {
                MixPanelService.track(`Details Panel View - FIR`, {
                    'Airspace Code': airspaceCode,
                    'Country Code': controllingCountryCode,
                    'FIR Name': FIRName,
                    'Countries': countries
                })

                // We are opening the FIR speific panel, and we need need to show information of airspace of one or many country airspaces
                this.showLoadingSkeleton()

                this.currentActiveModule = 'FIR'
                this.ativeFIRAirspaceIndex = 0
                this.isLoading = true

                document.getElementsByClassName('app-template')[0].classList.add('details-panel-show')

                const airspaceDetailsPromises = countries.map(countryCode => SecurityCMS.getCountryDetails(countryCode))

                Promise.all(airspaceDetailsPromises).then(values => {
                    let FlightInformationRegionDetails = cloneDeep(FIRDetails)
                    FlightInformationRegionDetails.name = FIRName
                    FlightInformationRegionDetails.code = airspaceCode

                    this.latestCreatedDateAirSpaceFIR = {}
                    for (let index = 0; index < values.length; index++) {
                        let countryDetails = COUNTRY_DETAILS.find(country => country.ISO_3166_1_ALPHA_3 === countries[index])
                        let airspaceDetails = this.getProcessedAirspaceData(countries[index], countryDetails.name, airspaceCode)
                        if (values[index]) {
                            values[index].forEach((result) => airspaceDetails = this.getProcessedAirspaceAPIResult(result, airspaceDetails, true))
                        }
                        this.checkForAnyAirspaceInformation(airspaceDetails)
                        FlightInformationRegionDetails.airspaces.push(airspaceDetails)
                    }

                    AvsecAlerts.getModuleLatestAlerts().then(aviationAlerts => {
                        FlightInformationRegionDetails.airspaces.forEach(airspace => {
                            aviationAlerts.forEach(avsecAlert => {
                                const countryAffected = avsecAlert.CountriesAffected.find(affectedCountry => affectedCountry.CountryCodeAlpha3 === airspace.ISO_3166_1_ALPHA_3)
                                if (!!countryAffected) {
                                    airspace.aviationAlerts.push({
                                        id: avsecAlert.NodeId,
                                        displayDateUTC: this.getDisplayDate(avsecAlert.Date),
                                        displayDateUTCWithTimeZone: this.getDisplayDateTime(avsecAlert.Date),
                                        heading: avsecAlert.Heading,
                                        isoCode: countryAffected.CountryCodeAlpha2,
                                        createdDate: avsecAlert.Date
                                    })
                                }
                            })
                        })

                        this.FIRDetails = FlightInformationRegionDetails
                        const FIRSpecificAlerts = aviationAlerts.filter(alert => alert.AffectedFIRs?.includes(airspaceCode))

                        this.FIRDetails.aviationAlerts = FIRSpecificAlerts.map(aviationAlertDetails => {
                            return {
                                id: aviationAlertDetails.NodeId,
                                displayDateUTC: this.getDisplayDate(aviationAlertDetails.Date),
                                displayDateUTCWithTimeZone: this.getDisplayDateTime(aviationAlertDetails.Date),
                                heading: aviationAlertDetails.Title,
                                isoCode: null,
                                createdDate: aviationAlertDetails.Date
                            }
                        })
                        this.FIRDetails.aviationAlerts = this.FIRDetails.aviationAlerts.sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate)))
                    }).finally(() => {
                        const activeTab = document.getElementsByClassName('details-panel__tab--button')[0]
                        const activeX = activeTab.offsetLeft
                        const activeWidth = activeTab.offsetWidth
                        const detailsPanelActiveTabFirIndicator = document.getElementById('details-panel-active-tab-indicator-fir')
                        detailsPanelActiveTabFirIndicator
                            .setAttribute("style", "width:" + parseInt(activeWidth) + "px;" + "transform: translateX(" + parseInt(activeX) + "px)")
                        this.isLoading = false
                        this.hideLoadingSkeleton()
                        console.log('Flight Information Region details after processing all airspaces', FlightInformationRegionDetails)
                    })
                })
            },
            getSecurityCMSAPIResponse(responseValue) {
                // API can return "Body" so it comes from the API, or it can be returned as "Content" which indicates
                // that it comes as RTE content from the CMS. This is valid for all API responses below
                if (responseValue !== null && responseValue.Body !== 'null' && !!responseValue.Body) {
                    // Try to parse it as JSON if it's a JSON format, otherwise it will fail, so we know it's just a string
                    try {
                        return JSON.parse(responseValue.Body)
                    } catch { return responseValue.Body }
                } else if (responseValue !== null && responseValue.Content !== 'null' && !!responseValue.Content) {
                    return responseValue.Content
                } else {
                    return ''
                }
            },
            showDetailsPanel(airportBasicData, currentActiveModule) {
                BriefBuilderComponent.hide(true)
                this.showLoadingSkeleton()

                // Reset active tab to overview when opening details panel
                this.currentActiveModule = 'airport'
                this.airportCurrentTab = 'Overview'

                if (currentActiveModule !== undefined) this.currentActiveModule = currentActiveModule

                const detailsPanelActiveTabIndicator = document.getElementById('details-panel-active-tab-indicator')
                if (detailsPanelActiveTabIndicator !== null) detailsPanelActiveTabIndicator.setAttribute("style", "width:108px;" + "transform: translateX(28px)")

                // Reset/re-initialize all the options when a new airport is opened
                this.airportDetails = cloneDeep(airportDetails)
                this.cityDetails = cloneDeep(cityDetails)
                this.countryDetails = cloneDeep(countryDetails)

                this.currentCountryCovidRestrictions = cloneDeep(countryCovidRestrictions)
                this.airportBasicData = airportBasicData
                this.isAirportPinned = AirportPins.isAirportPinned(this.airportBasicData.icao)
                this.isDetailsPanelOpen = true

                const covidDetails = this.findCountryCovidRestrictions(airportBasicData.countryCode3)
                if (covidDetails !== undefined) {
                    this.currentCountryCovidRestrictions = covidDetails
                    // The external API for some very small countries doesn't return the impacts property at all, so we need to initialize it with 0 values as not available
                    if (covidDetails.impactRatings === undefined) {
                        covidDetails.impactRatings = {
                            domesticOperations: 0,
                            travel: 0
                        }

                        this.currentCountryCovidRestrictions.tooltipContent = 'No Data Available'
                        this.currentCountryCovidRestrictions.domesticRatingDisplay = ''
                        this.currentCountryCovidRestrictions.travelRatingDisplay = ''
                    } else {
                        this.currentCountryCovidRestrictions.tooltipContent = this.covidRestrictions.covidImpactDefinitions.domesticOperations[covidDetails.impactRatings.domesticOperations - 1].definition + this.covidRestrictions.covidImpactDefinitions.travel[covidDetails.impactRatings.travel - 1].definition
                        this.currentCountryCovidRestrictions.domesticRatingDisplay = covidDetails.impactRatings.domesticOperations + ' - ' + this.covidRestrictions.covidImpactDefinitions.domesticOperations[covidDetails.impactRatings.domesticOperations - 1].rating
                        this.currentCountryCovidRestrictions.travelRatingDisplay = covidDetails.impactRatings.travel + ' - ' + this.covidRestrictions.covidImpactDefinitions.travel[covidDetails.impactRatings.travel - 1].rating
                    }

                    // For now we decided that the travel rating will be used for Covid rating not the average value
                    // this.currentCountryCovidRestrictions.generalRating = Math.ceil((covidDetails.impactRatings.domesticOperations + covidDetails.impactRatings.travel) / 2)
                    this.currentCountryCovidRestrictions.generalRating = covidDetails.impactRatings.travel
                }

                this.airspaceDetails = this.getProcessedAirspaceData(airportBasicData.countryCode3, airportBasicData.country)
                this.airportDetails.overview.airportType = airportBasicData.type
                this.airportDetails.overview.timeZone = airportBasicData.timeZone

                // 05R/23L:11598 x 148 ft. @ 23 ft.
                this.airportDetails.overview.runwaySpecs = ''
                ClientPortalAPIService.getAirportRunwayDetails(airportBasicData.icao).then(runwayResults => {
                    if (runwayResults.successful && runwayResults.data.length > 0) {
                        const longestRunway = runwayResults.data.reduce((prev, current) => (prev.length > current.length) ? prev : current)
                        const longestRunwayLastLetterIdentifier = longestRunway.identifier.slice(-1)
                        const allowedLetters = ['R', 'L', 'C']
                        const longestRunwayOppositeDirection = runwayResults.data.find(runway => {
                            const runwayLastLetterIdentifier = runway.identifier.slice(-1)

                            // If the longest runway has letter R indicating right runway, then the opposite direction is left runway L
                            // If the longest runway has letter L indicating left runway, then the opposite direction is right runway R
                            // If the longest runway has letter C indicating center runway, then the opposite direction is center runway C
                            // Haven't seen any other cases so far 

                            // Some simple runways don't have any last letter indicator
                            if (allowedLetters.indexOf(longestRunwayLastLetterIdentifier) === -1) {
                                return longestRunway.length === runway.length
                            } else {
                                return (
                                    (longestRunwayLastLetterIdentifier === 'R' && runwayLastLetterIdentifier === 'L') || (longestRunwayLastLetterIdentifier === 'L' && runwayLastLetterIdentifier === 'R') || longestRunwayLastLetterIdentifier === 'C'
                                ) &&
                                    longestRunway.length === runway.length
                            }
                        })

                        if (longestRunway !== undefined && longestRunwayOppositeDirection !== undefined) {
                            this.airportDetails.overview.runwaySpecs = longestRunwayOppositeDirection.identifier + '/' + longestRunway.identifier + ':' + longestRunway.length + ' x ' + longestRunway.width + ' ft. @ ' + airportBasicData.elevation + ' ft.'
                        }
                    }
                })

                SecurityCMS.getAirportDetails(airportBasicData.icao).then((airportResults) => {
                    try {
                        let latestCreatedDate = ''
                        if (airportResults) {
                            const resultNameToVariableMapper = {
                                'ground handling': 'overview.groundHandling',
                                'airport of entry': 'overview.airportEntry',
                                'international standard': 'overview.internationalStandard',
                                'airport contacts': 'overview.airportContacts',
                                'airport summary': 'operations.airportSummary',
                                'ground transportation': 'operations.groundTransport',
                                'airport security': 'security.assessment',
                                'security personnel': 'security.securityPersonnel',
                                'security features': 'security.securityFeatures'
                            }

                            airportResults.forEach((result) => {
                                const lowerCasedAPIName = result?.Name?.toLowerCase()
                                if (resultNameToVariableMapper[lowerCasedAPIName] !== undefined) {
                                    const paths = resultNameToVariableMapper[lowerCasedAPIName].split('.')
                                    let APIResult = this.getSecurityCMSAPIResponse(result.Value)

                                    // Special cases: sometimes it's returnes as object if it comes from an API or just a string if it comes
                                    // from the CMS, so we combine it here to always be as a string
                                    if (lowerCasedAPIName === 'runway specification' && typeof APIResult === 'object') {
                                        APIResult = APIResult.runwayId + ':' + APIResult.runwayLength + ' x ' + APIResult.runwayWidth + ' ft. @ ' + APIResult.elevation + ' ft.'
                                    }

                                    if (lowerCasedAPIName === 'airport of entry' && typeof APIResult === 'object') {
                                        APIResult = APIResult.airportEntry
                                    }

                                    if (lowerCasedAPIName === 'ground handling' && typeof APIResult === 'object') {
                                        if (APIResult.slotsRequired) {
                                            APIResult = 'Slots Required <br />'
                                        } else {
                                            APIResult = 'Slots Not Required <br />'
                                        }

                                        if (APIResult.handlingMandatory) {
                                            APIResult += 'Handling Required <br />'
                                        } else {
                                            APIResult += 'Handling Not Required <br />'
                                        }
                                    }

                                    if (paths.length === 1) {
                                        this.airportDetails[resultNameToVariableMapper[lowerCasedAPIName]] = APIResult
                                    } else if (paths.length === 2) {
                                        this.airportDetails[paths[0]][paths[1]] = APIResult
                                    }

                                    if (result.ContentType !== 'API-Content') {
                                        let createdDate = result.CreatedDate ? moment(result.CreatedDate + 'Z') : ''
                                        if (createdDate.isAfter(latestCreatedDate) || latestCreatedDate === '') latestCreatedDate = createdDate
                                    }
                                }

                                if (lowerCasedAPIName === 'airport map' && result.Value.Content !== 'null' && !!result.Value.Content) {
                                    const imagePath = extractImageRelativePathFromDOMString(result.Value.Content)
                                    if (imagePath !== '') this.airportDetails.overview.airportMapURL = config.MedaireSecurityCMSPortal + imagePath
                                }
                                if (result.ContentType === 'Airport') {
                                    let createdDate = result.CreatedDate ? moment(result.CreatedDate + 'Z') : ''
                                    if (createdDate.isAfter(latestCreatedDate) || latestCreatedDate === '') latestCreatedDate = createdDate
                                }
                            })
                        }

                        this.airportDetails.publishedDate = latestCreatedDate || ''
                        // Added this because it was flashing content and did not look good (can look to improve later)
                        setTimeout(() => this.hideLoadingSkeleton(), 800)
                    } catch (error) {
                        console.log("SecurityCMS Get Airports Details", error)
                    }
                })


                SecurityCMS.getCityDetails(airportBasicData.countryCode3, airportBasicData.cityName, airportBasicData.icao).then((cityResults) => {
                    try {
                        if (cityResults) {
                            const resultNameToVariableMapper = {
                                'city security overview': 'overview.securityOverview',
                                'orientation': 'overview.orientation',
                                'calendar': 'overview.cityCalendar',
                                'crime': 'security.crime',
                                'seeking help': 'security.seekingHelp',
                                'social unrest': 'security.socialUnrest',
                                'terrorism': 'security.terrorism',
                                'trouble spots': 'security.troubleSpots',
                                'embassies and consulates': 'keyinfo.diplomaticRepresentation',
                                'emergency medical care': 'keyinfo.emergencyMedicalCare',
                                'emergency numbers': 'keyinfo.emergencyNumbers',
                                'lodging': 'keyinfo.lodging',
                                'to city centre': 'transport.toCityCentre',
                                'taxis': 'transport.Taxis',
                                'public transport': 'transport.publicTransport',
                                'walking': 'transport.walking',
                                'car hire': 'transport.carHire'
                            }

                            cityResults.forEach((result) => {
                                const lowerCasedAPIName = result?.Name?.toLowerCase()
                                if (resultNameToVariableMapper[lowerCasedAPIName] !== undefined) {
                                    const paths = resultNameToVariableMapper[lowerCasedAPIName].split('.')
                                    if (paths.length === 1) {
                                        this.cityDetails[resultNameToVariableMapper[lowerCasedAPIName]] = this.getSecurityCMSAPIResponse(result.Value)
                                    } else if (paths.length === 2) {
                                        this.cityDetails[paths[0]][paths[1]] = this.getSecurityCMSAPIResponse(result.Value)
                                    }
                                }
                            })

                            // Now call city guides, so the values from the API can override eventual content blocks from Security CMS
                            ClientPortalAPIService.getCountryGuideCityInfo(airportBasicData.countryCode, airportBasicData.cityName).then(countryGuideResults => {
                                if (countryGuideResults !== null) {
                                    const countryGuide = countryGuideResults?.countries?.[0]?.cities?.filter(function (item) {
                                        return item.name == airportBasicData.cityName
                                    }) || []

                                    countryGuide.forEach((result) => {
                                        if (result.title === 'TO CITY CENTRE' && result.body !== 'null' && !!result.body)
                                            this.cityDetails.transport.toCityCentre = result.body
                                        if (result.title === 'TAXIS' && result.body !== 'null' && !!result.body)
                                            this.cityDetails.transport.taxis = result.body
                                        if (result.title === 'PUBLIC TRANSPORT' && result.body !== 'null' && !!result.body)
                                            this.cityDetails.transport.publicTransport = result.body
                                        if (result.title === 'WALKING' && result.body !== 'null' && !!result.body)
                                            this.cityDetails.transport.walking = result.body
                                        if (result.title === 'CAR HIRE' && result.body !== 'null' && !!result.body)
                                            this.cityDetails.transport.carHire = result.body
                                    })
                                }
                            })
                        }
                    } catch (error) {
                        console.log('SecurityCMS Get City Details', error)
                    }
                })

                SecurityCMS.getCountryDetails(airportBasicData.countryCode3).then((countryResults) => {
                    try {
                        this.latestCreatedDateAirSpace = ''
                        if (countryResults) {
                            const resultNameToVariableMapper = {
                                'country assessment': 'overview.assessment',
                                'conclusion': 'overview.conclusion',
                                'local emergency numbers': 'overview.emergencyNumbers',
                                'country travel risk summary': 'travel.riskSummary',
                                'standing travel advice': 'travel.standingTravelAdvice',
                                'country business women': 'travel.businessWomen',
                                'country rule of law': 'background.countryRuleOfLaw',
                                'country travel and security alerts': 'travel.securityAlerts',
                                'country conflict': 'background.countryConflict',
                                'political situation': 'background.politicalSituation',
                                'country corruption': 'background.countryCorruption',
                                'border concerns': 'background.borderConcerns',
                                'country social unrest': 'background.socialUnrest',
                                'country natural disasters': 'background.naturalDisasters',
                                'country recent history': 'background.recentHistory'
                            }
                            countryResults?.forEach((result) => {
                                const lowerCasedAPIName = result?.Name?.toLowerCase()
                                if (resultNameToVariableMapper[lowerCasedAPIName] !== undefined) {
                                    const paths = resultNameToVariableMapper[lowerCasedAPIName].split('.')
                                    if (paths.length === 1) {
                                        this.countryDetails[resultNameToVariableMapper[lowerCasedAPIName]] = this.getSecurityCMSAPIResponse(result.Value)
                                    } else if (paths.length === 2) {
                                        this.countryDetails[paths[0]][paths[1]] = this.getSecurityCMSAPIResponse(result.Value)
                                    }
                                }

                                this.airspaceDetails = this.getProcessedAirspaceAPIResult(result, this.airspaceDetails)
                            })
                            this.airspaceDetails.publishedDate = this.latestCreatedDateAirSpace || ''
                            this.checkForAnyAirspaceInformation(this.airspaceDetails)
                        }
                    } catch (error) {
                        console.log("SecurityCMS Get Country Details", error)
                    }
                })

                let isCountryGuideMedicalSummaryMedicalInfoResponse = false
                let isCountryGuideMedicalCareMedicalInfoResponse = false
                let isCountryGuideDiseasesMedicalInfoResponse = false
                let isCountryGuideGeneralDiseaseAndPreventionContentMedicalInfoResponse = false
                let isCountryGuideMedicalReferralsMedicalInfoResponse = false

                if (this.userPermissions.indexOf('medical') > -1) {
                    this.countryDetails.medical.isMedicalLoading = true;
                    const checkMedicalLoadings = () => {
                        if (isCountryGuideMedicalSummaryMedicalInfoResponse && isCountryGuideMedicalCareMedicalInfoResponse && isCountryGuideDiseasesMedicalInfoResponse && isCountryGuideGeneralDiseaseAndPreventionContentMedicalInfoResponse && isCountryGuideMedicalReferralsMedicalInfoResponse) {
                            this.countryDetails.medical.isMedicalLoading = false
                            this.isParentObjectEmptyForBriefBuilder()
                        }
                    }
                    ClientPortalAPIService.GetCountryGuideMedicalSummaryMedicalInfo(airportBasicData.countryCode).then((medicalSummaryMedicalInfo) => {

                        if (medicalSummaryMedicalInfo) {
                            this.countryDetails.medical.waterrisk = medicalSummaryMedicalInfo.waterrisk
                            this.countryDetails.medical.foodrisk = medicalSummaryMedicalInfo.foodrisk
                            this.countryDetails.medical.vaccination = medicalSummaryMedicalInfo.vaccination
                            this.countryDetails.medical.routinevaccination = medicalSummaryMedicalInfo.routinevaccination
                            this.countryDetails.medical.medicalalertteaser = medicalSummaryMedicalInfo.medicalalertteaser
                        }
                    }).finally(() => {
                        isCountryGuideMedicalSummaryMedicalInfoResponse = true
                        checkMedicalLoadings()
                    })
                    ClientPortalAPIService.GetCountryGuideMedicalCareMedicalInfo(airportBasicData.countryCode).then((medicalCareMedicalInfo) => {

                        if (medicalCareMedicalInfo) {
                            this.countryDetails.medical.emgresponse = medicalCareMedicalInfo.emgresponse
                            this.countryDetails.medical.outpatientcare = medicalCareMedicalInfo.outpatientcare
                            this.countryDetails.medical.healthcarepayment = medicalCareMedicalInfo.healthcarepayment
                            this.countryDetails.medical.dentalcare = medicalCareMedicalInfo.dentalcare
                            this.countryDetails.medical.availmeds = medicalCareMedicalInfo.availmeds
                            this.countryDetails.medical.bloodsupplies = medicalCareMedicalInfo.bloodsupplies
                        }
                    }).finally(() => {
                        isCountryGuideMedicalCareMedicalInfoResponse = true
                        checkMedicalLoadings()
                    })

                    ClientPortalAPIService.GetCountryGuideDiseasesMedicalInfo(airportBasicData.countryCode).then((diseasesMedicalInfo) => {
                        if (diseasesMedicalInfo) {
                            this.countryDetails.medical.diseases = diseasesMedicalInfo.disease
                        }
                    }).finally(() => {
                        isCountryGuideDiseasesMedicalInfoResponse = true
                        checkMedicalLoadings()
                    })

                    ClientPortalAPIService.GetCountryGuideGeneralDiseaseAndPreventionContentMedicalInfo(airportBasicData.countryCode).then((generalDiseaseAndPreventionContentMedicalInfo) => {
                        if (generalDiseaseAndPreventionContentMedicalInfo) {
                            this.countryDetails.medical.GeneralDiseaseAndPreventionContent = generalDiseaseAndPreventionContentMedicalInfo.articlecontent
                        }
                    }).finally(() => {
                        isCountryGuideGeneralDiseaseAndPreventionContentMedicalInfoResponse = true
                        checkMedicalLoadings()
                    })



                    ClientPortalAPIService.GetCountryGuideMedicalReferralsMedicalInfo(airportBasicData.countryCode).then((medicalReferralsMedicalInfo) => {
                        if (medicalReferralsMedicalInfo && medicalReferralsMedicalInfo.hospitalcitynames && medicalReferralsMedicalInfo.hospitals) {
                            const cityHospital = [];
                            medicalReferralsMedicalInfo.hospitalcitynames.forEach(cityObj => {
                                const obj = {
                                    cityName: cityObj.city,
                                    list: medicalReferralsMedicalInfo.hospitals.filter(obj => obj.city === cityObj.city)
                                }
                                cityHospital.push(obj)
                            })

                            // iterate over each city in the original object
                            for (const city of cityHospital) {
                                const hospitalParsed = []
                                const existingHospitalPhoneNumbers = {}

                                city.list = city.list.filter(hospital => {
                                    if (existingHospitalPhoneNumbers[hospital.providerid] === undefined) {
                                        existingHospitalPhoneNumbers[hospital.providerid] = []
                                    }
                                    existingHospitalPhoneNumbers[hospital.providerid].push(hospital.phonenumber)
                                    if (hospitalParsed.indexOf(hospital.providerid) === -1) {
                                        hospitalParsed.push(hospital.providerid)
                                        return true
                                    } else {
                                        return false
                                    }
                                })

                                city.list = city.list.map(hospital => {
                                    return {
                                        ...hospital,
                                        phonenumber: existingHospitalPhoneNumbers[hospital.providerid].join(', ')
                                    }
                                })
                            }
                            this.countryDetails.medical.medicalReferrals = cityHospital
                        }
                    }).finally(() => {
                        isCountryGuideMedicalReferralsMedicalInfoResponse = true
                        checkMedicalLoadings()
                    })


                    console.log(this.countryDetails.medical.isMedicalLoading)
                }

                ClientPortalAPIService.getCountryGuideEntryExitInfo(airportBasicData.countryCode).then(entryExitInfo => {
                    if (entryExitInfo !== null) {
                        this.countryDetails.travel.entryExitRequirements = entryExitInfo.passportvisadetails
                    } else {
                        this.countryDetails.travel.entryExitRequirements = ''
                    }
                })

                // Get city International SOS alerts & get country International SOS alerts and Avsec alerts
                const alertPromise = InternationalSOSAlerts.getModuleLatestAlerts()
                const avsecAlertsPromise = AvsecAlerts.getModuleLatestAlerts()
                const avsecAirportAlertsPromise = AvsecAlerts.getModuleAirportAlerts(airportBasicData.icao)
                const avsecCityAlertsPromise = AvsecAlerts.getModuleCityAlerts(airportBasicData.icao)
                const avsecCountryAlertsPromise = AvsecAlerts.getModuleCountryAlerts(airportBasicData.countryCode3)

                Promise.all([alertPromise, avsecAlertsPromise, avsecAirportAlertsPromise, avsecCityAlertsPromise, avsecCountryAlertsPromise]).then(values => {
                    const cityAlerts = filterInternationalSOSAlerts(values[0], [airportBasicData.latitude, airportBasicData.longitude])
                    const countryAlerts = filterInternationalSOSCountryAlerts(values[0], airportBasicData.countryCode3)

                    let simplifiedCityAlers = []
                    cityAlerts.forEach(alert => {
                        simplifiedCityAlers.push({
                            id: alert.Id,
                            displayDateUTC: alert.CreatedDate !== '' ? this.getDisplayDate(alert.CreatedDate) : '',
                            displayDateUTCWithTimeZone: alert.CreatedDate !== '' ? this.getDisplayDateTime(alert.CreatedDate) : '',
                            heading: alert.Title,
                            distanceFromAirport: alert.distanceFromAirport,
                            alertType: alert.Service,
                            createdDate: alert.CreatedDate,
                            activeFrom: alert.ActiveFrom,
                            activeTo: alert.ActiveTo,
                            type: 'aviation'
                        })
                    })

                    // Sort by distance from airport
                    this.cityDetails.alerts = simplifiedCityAlers.sort((a, b) => a.distanceFromAirport - b.distanceFromAirport)

                    countryAlerts.forEach(alert => {
                        this.countryDetails.alerts.push({
                            id: alert.Id,
                            displayDateUTC: alert.CreatedDate !== '' ? this.getDisplayDate(alert.CreatedDate) : '',
                            displayDateUTCWithTimeZone: alert.CreatedDate !== '' ? this.getDisplayDateTime(alert.CreatedDate) : '',
                            heading: alert.Title,
                            alertType: alert.Service,
                            createdDate: alert.CreatedDate,
                            activeFrom: alert.ActiveFrom,
                            activeTo: alert.ActiveTo,
                            type: 'aviation'
                        })
                    })

                    values[1].forEach(avsecAlert => {
                        const countryAffected = avsecAlert.CountriesAffected.find(affectedCountry => affectedCountry.CountryCodeAlpha3 === airportBasicData.countryCode3)
                        if (countryAffected) {
                            this.airspaceDetails.aviationAlerts.push({
                                id: avsecAlert.NodeId,
                                displayDateUTC: this.getDisplayDate(avsecAlert.Date),
                                displayDateUTCWithTimeZone: this.getDisplayDateTime(avsecAlert.Date),
                                heading: avsecAlert.Heading,
                                isoCode: countryAffected.CountryCodeAlpha2,
                                createdDate: avsecAlert.Date,
                                type: 'aviation'
                            })
                        }
                    })

                    let simplifiedAirportAlers = []
                    values[2].forEach(avsecAlert => {
                        let distanceFromAirport = 0
                        if (!!avsecAlert?.AffectedLocation) {
                            distanceFromAirport = findIfAlertsAreInAirportRange(avsecAlert?.AffectedLocation, [airportBasicData.latitude, airportBasicData.longitude])
                        }
                        simplifiedAirportAlers.push({
                            id: avsecAlert.NodeId,
                            displayDateUTC: this.getDisplayDate(avsecAlert.Date),
                            displayDateUTCWithTimeZone: this.getDisplayDateTime(avsecAlert.Date),
                            heading: avsecAlert.Title,
                            isoCode: avsecAlert.IsoCode,
                            isBreaking: avsecAlert.IsBreaking,
                            breakingAlertStatus: avsecAlert.IsBreaking ? avsecAlert.AlertStatus : undefined,
                            isAirportOnly: avsecAlert.isAirportOnly,
                            distanceFromAirport: distanceFromAirport,
                            alertType: avsecAlert.IsBreaking ? "Aviation - Breaking" : 'Aviation',
                            createdDate: avsecAlert.Date,
                            type: "avsec"
                        })
                    })

                    this.airportDetails.aviationAlerts = simplifiedAirportAlers

                    let simplifiedAvsecCityAlers = []
                    values[3].forEach(avsecAlert => {
                        let distanceFromAirport = findIfAlertsAreInAirportRange(avsecAlert?.AffectedLocation, [airportBasicData.latitude, airportBasicData.longitude])
                        simplifiedAvsecCityAlers.push({
                            id: avsecAlert.NodeId,
                            displayDateUTC: this.getDisplayDate(avsecAlert.Date),
                            displayDateUTCWithTimeZone: this.getDisplayDateTime(avsecAlert.Date),
                            heading: avsecAlert.Title,
                            isoCode: avsecAlert.IsoCode, // This seems to be legacy property, will need to consider removing it?
                            isBreaking: avsecAlert.IsBreaking,
                            breakingAlertStatus: avsecAlert.IsBreaking ? avsecAlert.AlertStatus : undefined,
                            distanceFromAirport: distanceFromAirport,
                            alertType: avsecAlert.IsBreaking ? "Aviation - Breaking" : 'Aviation',
                            createdDate: avsecAlert.Date,
                            type: "avsec"
                        })
                    })

                    this.cityDetails.aviationAlerts = simplifiedAvsecCityAlers

                    let simplifiedAvsecCountryAlers = []
                    values[4].forEach(avsecAlert => {
                        simplifiedAvsecCountryAlers.push({
                            id: avsecAlert.NodeId,
                            displayDateUTC: this.getDisplayDate(avsecAlert.Date),
                            displayDateUTCWithTimeZone: this.getDisplayDateTime(avsecAlert.Date),
                            heading: avsecAlert.Title,
                            isoCode: avsecAlert.IsoCode, // This seems to be legacy property, will need to consider removing it?
                            isBreaking: avsecAlert.IsBreaking,
                            breakingAlertStatus: avsecAlert.IsBreaking ? avsecAlert.AlertStatus : undefined,
                            alertType: avsecAlert.IsBreaking ? "Aviation - Breaking" : 'Aviation',
                            createdDate: avsecAlert.Date,
                            type: "avsec"
                        })
                    })
                    this.countryDetails.aviationAlerts = simplifiedAvsecCountryAlers


                    this.allAirportAlertAlerts = [
                        ...this.cityDetails?.alerts || [],
                        ...this.airportDetails?.aviationAlerts || []].sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate)))
                    this.allCityAlertAlerts = [
                        ...this.cityDetails?.alerts || [],
                        ...this.cityDetails?.aviationAlerts || []].sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate)))
                    this.allCountryAlerts = [
                        ...this.countryDetails?.alerts || [],
                        ...this.countryDetails?.aviationAlerts || []].sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate)))
                    this.allAirspaceAlerts = [
                        ...this.airspaceDetails?.aviationAlerts || []].sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate)))
                })


                // ...this.cityDetails.alerts, ...this.countryDetails.alerts,...this.airportDetails.aviationAlerts,
                // ...this.cityDetails.aviationAlerts, ...this.countryDetails.aviationAlerts

                MixPanelService.track('Airport View', {
                    'Airport Name': airportBasicData.airportName,
                    'Airport Details': `${airportBasicData.icao}${(airportBasicData.iata !== '' ? ' | ' + airportBasicData.iata : '')} | ${airportBasicData.cityName}, ${airportBasicData.country}`
                })

                this.isParentObjectEmptyForBriefBuilder()

                document.getElementsByClassName('app-template')[0].classList.add('details-panel-show')

                if (airportBasicData.longitude !== undefined && airportBasicData.latitude !== undefined) {
                    this.triggerOpeningEffect([airportBasicData.longitude, airportBasicData.latitude])
                }
            },
            triggerOpeningEffect(lngLat) {
                setTimeout(() => {
                    if (lngLat !== undefined) MapBox.map.jumpTo({ center: lngLat })

                    this.$nextTick(() => {
                        const clientWidth = document.documentElement.clientWidth
                        const detailsPanelElement = document.querySelector('#vue-details-panel .details-panel').getClientRects()[0]
                        const options = {
                            duration: 0
                        }

                        // Horizontal mode, small screens; We donn't want to support desktop
                        if (clientWidth > 768 && clientWidth < 1200) {
                            options.padding = {
                                'bottom': 0,
                                'right': detailsPanelElement.width
                            }
                        } else if (clientWidth <= 768) { // Mobile, Potrait
                            options.padding = {
                                'right': 0,
                                'bottom': detailsPanelElement.height
                            }
                        }

                        MapBox.map.easeTo(options)
                    })
                })
            },
            openAlert(alert, isAviationAlert, aviationAlertType) {
                if (aviationAlertType === 'country') {
                    AvsecAlerts.showCountryAlerts(alert.isoCode)
                    return
                } else if (alert.type === 'aviation') {
                    InternationalSOSAlerts.showAlert(alert.id)
                    return
                } else if (alert.type === "avsec") {
                    AvsecAlerts.showAlert(alert.id, 'location')
                    return
                } else if (aviationAlertType === 'alert') {
                    AvsecAlerts.showAlert(alert.id, 'alert')
                } else {
                    InternationalSOSAlerts.showAlert(alert.id)
                }


                // if (!!isAviationAlert) {
                //     if (aviationAlertType === 'airport') {
                //         AvsecAlerts.showAirportAlert(alert.id, this.airportBasicData.icao)
                //     } else if (aviationAlertType === 'alert') {
                //         AvsecAlerts.showAlert(alert.id, 'alert')
                //     } else if (aviationAlertType === 'country') {
                //         AvsecAlerts.showCountryAlerts(alert.isoCode)
                //     } else if (aviationAlertType === 'aviation') {
                //         AvsecAlerts.showAlert(alert.id, 'location')
                //     }
                // } else {
                //     InternationalSOSAlerts.showAlert(alert.id)
                // }
            },
            hideDetailsPanel() {
                document.getElementsByClassName('app-template')[0].classList.remove('details-panel-show')
                this.isDetailsPanelOpen = false

                AeroSpace.clearFIRSelection()

                unhighlightCountry()
            },
            isObjectEmpty(obj) {
                if (obj == null) return true
                return Object.keys(obj).length === 0
            },
            isParentObjectEmpty(obj, fieldsToIgnore) {
                let areAllPropertiesEmpty = true

                for (const key in obj) {
                    if (Object.hasOwnProperty.call(obj, key)) {
                        const objectProperty = obj[key]

                        if ((typeof objectProperty === 'string' && objectProperty !== '') || !this.isObjectEmpty(objectProperty)) {
                            if (fieldsToIgnore === undefined || (fieldsToIgnore !== undefined && fieldsToIgnore.indexOf(key) === -1)) {
                                areAllPropertiesEmpty = false
                                break
                            }
                        }
                    }
                }

                return areAllPropertiesEmpty
            },
            isParentObjectEmptyForBriefBuilder() {
                let data = []
                let type = ''
                if (this.currentActiveModule === 'airport') {
                    type = 'airport-details-panel'
                } else if (this.currentActiveModule === 'city') {
                    type = 'city-details-panel'
                } else if (this.currentActiveModule === 'country') {
                    type = 'country-details-panel'
                } else if (this.currentActiveModule === 'airspace') {
                    type = 'airspace-details-panel'
                } else if (this.currentActiveModule === 'FIR') {
                    type = 'fir-details-panel'
                }

                const tabs = document.querySelectorAll(`#${type} .details-panel__sidebar-tabs`)
                tabs?.forEach(res => {
                    if (res?.children?.[0]?.classList?.contains("is-disabled-tab")) {
                        data.push(true)
                    }
                })

                if (data?.length === tabs?.length) {
                    document.getElementsByClassName('generate-report')?.[0]?.classList?.add('disabled')
                } else {
                    document.getElementsByClassName('generate-report')?.[0]?.classList?.remove('disabled')
                }

                if (this.countryDetails.medical.isMedicalLoading) {
                    document.getElementsByClassName('generate-report')?.[0]?.classList?.add('is-loading')
                } else {
                    document.getElementsByClassName('generate-report')?.[0]?.classList?.remove('is-loading')
                }

            },
            togglePinAirport() {
                if (this.isAirportPinned) {
                    AirportPins.removeAirport(this.airportBasicData.icao)
                } else {
                    AirportPins.addAirport(this.airportBasicData.icao)
                    MixPanelService.track('Airport Pinned', {
                        'Airport Name': this.airportBasicData.airportName,
                        'ICAO': this.airportBasicData.icao,
                        'IATA': this.airportBasicData.iata,
                        'Country': this.airportBasicData.country,
                        'Country Code': this.airportBasicData.countryCode3,
                        'City': this.airportBasicData.cityName 
                    })
                }

                this.isAirportPinned = !this.isAirportPinned
                this.hideDetailsPanel()
            },
            getLengthOfPinnedItems() {
                return AirportPins.$data.pinnedAirports.length
            },
            getCurrentPinnedIndex() {
                return AirportPins.findAirportIndex(this.airportBasicData.icao)
            },
            previousPinnedItem() {
                AirportPins.openPreviousPinnedItem()
            },
            nextPinnedItem() {
                AirportPins.openNextPinnedItem()
            },
            getDisplayDateTime(timestamp) {
                return moment(timestamp).format('DD MMM YYYY HH:mm') + ' ' + guessedTimeZone
            },
            getDisplayDate(UTCDate) {
                return moment(UTCDate).format('DD MMM YYYY') + ' ' + guessedTimeZone
            },
            getMedicalRishRatingDescription(medicalRisk) {
                return riskDefinitions.medical[medicalRisk]
            },
            selectDetailsPanel(moduleName, event) {
                if (event) {
                    if (event.type !== undefined) {
                        var activeTab = event.target
                    } else {
                        var activeTab = event
                    }
                }
                const activeX = activeTab.offsetLeft
                const activeWidth = activeTab.offsetWidth
                const detailsPanelActiveTabIndicator = document.getElementById('details-panel-active-tab-indicator')
                detailsPanelActiveTabIndicator
                    .setAttribute('style', 'width:' + parseInt(activeWidth) + 'px;' + 'transform: translateX(' + parseInt(activeX) + 'px)')
                this.currentActiveModule = moduleName
                if (moduleName === 'country') {
                    highlightCountry(this.airportBasicData.countryCode, this.airportBasicData.longitude, this.airportBasicData.latitude)
                } else {
                    unhighlightCountry([this.airportBasicData.longitude, this.airportBasicData.latitude])
                }

                if (moduleName === 'airspace') {
                    mapflyToLocation(this.airportBasicData.longitude, this.airportBasicData.latitude)
                }

                let mixpanelData = {}
                if (moduleName === 'airport') {
                    mixpanelData = {
                        'Airport Name': this.airportBasicData.airportName,
                        'ICAO': this.airportBasicData.icao,
                        'IATA': this.airportBasicData.iata,
                        'Country': this.airportBasicData.country,
                        'Country Code': this.airportBasicData.countryCode3,
                        'City': this.airportBasicData.cityName
                    }
                } else if (moduleName === 'city') {
                    mixpanelData = {
                        'City': this.airportBasicData.cityName,
                        'Country': this.airportBasicData.country,
                        'Country Code': this.airportBasicData.countryCode3
                    }
                } else if (moduleName === 'country' || moduleName === 'airspace') {
                    mixpanelData = {
                        'Country': this.airportBasicData.country,
                        'Country Code': this.airportBasicData.countryCode3
                    }
                }
                MixPanelService.track(`Details Panel View - ${moduleName}`, mixpanelData)
                
                this.isParentObjectEmptyForBriefBuilder()
            },
            setDetailPanelActiveTab() {
                const countryTab = document.getElementById('details-panel-country-tab')
                const cityTab = document.getElementById('details-panel-city-tab')
                if (this.airportBasicData.inheritedCityRating) {
                    this.selectDetailsPanel('country', countryTab)
                } else {
                    this.selectDetailsPanel('city', cityTab)
                }
            },

            selectDetailsPanelFirTab(index, event) {
                if (event) {
                    if (event.type !== undefined) {
                        var activeTab = event.target
                    } else {
                        var activeTab = event
                    }
                }
                var activeX = activeTab.offsetLeft
                var activeWidth = activeTab.offsetWidth
                const detailsPanelActiveTabFirIndicator = document.getElementById('details-panel-active-tab-indicator-fir')
                detailsPanelActiveTabFirIndicator
                    .setAttribute("style", "width:" + parseInt(activeWidth) + "px;" + "transform: translateX(" + parseInt(activeX) + "px)")
                this.ativeFIRAirspaceIndex = index
            },
            openReportGeneration() {
                let reportType = this.currentActiveModule
                if (this.currentActiveModule === 'FIR') reportType = 'airspace'
                const availableData = cloneDeep(this.getExportedData())


                if (availableData?.cityDetails) {
                    availableData.cityDetails.alerts = [...availableData?.cityDetails?.alerts || [], ...availableData?.cityDetails?.aviationAlerts || []]
                }

                if (availableData?.countryDetails) {
                    const countryDetails = COUNTRY_DETAILS.find(country => country.ISO_3166_1_ALPHA_3 === this.airportBasicData.countryCode3)
                    availableData.countryDetails.alerts = [...availableData?.countryDetails?.alerts || [], ...availableData?.countryDetails?.aviationAlerts || []]
                }
                BriefBuilderComponent.open(reportType, availableData)

                MixPanelService.track('Generate Report', {
                    'Current Tab': this.currentActiveModule,
                    'Type': reportType
                })
            },
            getExportedData() {
                let exportedData = {}
                exportedData.countryDetails = cloneDeep(this.countryDetails)
                exportedData.countryDetails.travel.travelRestrictions = this.currentCountryCovidRestrictions.restrictionList
                exportedData.airspaceDetails = this.airspaceDetails
                exportedData.cityName = this.airportBasicData.cityName
                exportedData.countryName = this.airportBasicData.country
                exportedData.covidImpactRatings = this.currentCountryCovidRestrictions.impactRatings
                exportedData.countryRating = this.airportBasicData.countryRating
                if (this.userPermissions.indexOf('medical') > -1) {
                    exportedData.medicalRating = this.airportBasicData.medicalRating
                }

                if (!!exportedData.countryDetails.travel && exportedData.countryDetails.travel.securityAlerts !== undefined && typeof exportedData.countryDetails.travel.securityAlerts === 'string') {
                    exportedData.countryDetails.travel.securityAlerts = null
                }

                if (this.currentActiveModule === 'city') {
                    exportedData.cityDetails = this.cityDetails
                    exportedData.cityRating = this.airportBasicData.cityRating
                } else if (this.currentActiveModule === 'airport') {
                    exportedData.cityDetails = this.cityDetails
                    exportedData.airportDetails = this.airportDetails
                    exportedData.airportBasicData = this.airportBasicData
                } else if (this.currentActiveModule === 'FIR') {
                    // In this case we just pass airspace details of the currently active airspace, we don't have FIR specific report
                    exportedData.airspaceDetails = this.FIRDetails.airspaces[this.ativeFIRAirspaceIndex]
                    exportedData.countryName = this.FIRDetails.airspaces[this.ativeFIRAirspaceIndex].countryName
                }
                return exportedData
            },
            isWeaponaryTypeAvailable(weaponaryTypeName, countryThreatTypes) {
                return countryThreatTypes !== undefined && countryThreatTypes.some(threatType => threatType.ThreatName === weaponaryTypeName)
            },
            addAirportToWatchlist(airportICAO) {
                ModalComponent.$data.airportCodeToAdd = airportICAO
                ModalComponent.$data.showWatchlistModal = true
                ModalComponent.$data.addToWatchFromLocation = 'Details panel'
            },
            shouldDisplayExportButton() {
                if (this.currentActiveModule === 'FIR' && this.FIRDetails.airspaces.length > 0) {
                    return this.FIRDetails.airspaces[this.ativeFIRAirspaceIndex].anyInformation
                }

                return this.currentActiveModule !== 'airspace' || (this.currentActiveModule === 'airspace' && this.airspaceDetails.anyInformation)
            },
            mixpanelTrackAirports(type) {
                MixPanelService.track(type, {
                    'Clicked Location': 'Details Panel',
                    'Airport Name': this.airportBasicData?.airportName || '',
                    'ICAO': this.airportBasicData?.icao || '',
                    'IATA': this.airportBasicData?.iata || '',
                    'Country': this.airportBasicData?.country || '',
                    'Country Code': this.airportBasicData?.countryCode3 || '',
                    'City': this.airportBasicData?.cityName || ''
                })
            },
            compare() {
                this.mixpanelTrackAirports('Page View - Compare')
                Compare.addAirport(this.airportBasicData.icao)
                Compare.show()
            },
            
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-details-panel')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el) {
                        tippy(el, {
                            content: '',
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter click focus',
                            arrow: false,
                            interactive: true,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    },
                    updated(el, binding, vnode) {
                        // https://atomiks.github.io/tippyjs/v6/tippy-instance/#-property
                        el._tippy.setContent(vnode.props.content)
                    }
                })
            }
        })
            .use(Donut)
            .mount(DOMElement)
    }
})();